import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-genders',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-genders-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-genders-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-genders-index" */ '@/modules/configurations/catalogs/catalog-genders/views/Index.vue')
        }
    ]
}
